// 导入各模块的中文翻译文件
import pages from '../namespaces/pages/zh-CN';
import components from '../namespaces/components/zh-CN';
import common from '../namespaces/common/zh-CN';
import errors from '../namespaces/errors/zh-CN';
import validation from '../namespaces/validation/zh-CN';
import gameDetail from '../namespaces/gameDetail/zh-CN';

// 导出合并后的翻译
export default {
  common,
  pages,
  components,
  errors,
  validation,
  gameDetail
};